// extracted by mini-css-extract-plugin
export var entityChip = "_sf-0";
export var entityChipMissing = "_sf-1";